import { Text } from 'rebass';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Avatar from './Avatar';
import useStoryMembers from '../hooks/useStoryMembers';

const ShareAvatars = ({ truncateAt }) => {
  const storyMembers = useStoryMembers();
  const visibleMembers = storyMembers.slice(0, truncateAt).reverse();
  const additionalMembers = storyMembers.slice(truncateAt).length;

  return (
    <Wrap>
      <Text fontSize={[0, 0, 1]} color="white" mb={10} fontFamily="sans">
        Shared with {`(${storyMembers.length})`}
      </Text>
      <AvatarsWrap>
        {!!additionalMembers && (
          <Avatar overflowCount={additionalMembers} border size={[30, 30, 34, 36]} />
        )}
        {visibleMembers.map(member => (
          <Avatar
            avatarUrl={member['avatar-url']}
            name={member['full-name']}
            border
            key={`${member.id}`}
            size={[30, 30, 34, 36]}
          />
        ))}
      </AvatarsWrap>
    </Wrap>
  );
};

ShareAvatars.propTypes = {
  truncateAt: PropTypes.number.isRequired,
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 0 auto;
  align-items: flex-end;
`;

const AvatarsWrap = styled.div`
  all: unset;
  display: flex;
  flex-direction: row-reverse; /* row reverse allows the z-index to work automatically */
  padding: 0 4px;

  & > * {
    margin: 0 -4px;
  }
`;

export default ShareAvatars;
